module.exports = __webpack_public_path__ + "img/head-side-brain.a2c999da.svg";